import ReactGA from 'react-ga4';

const isDevelop =
  window.location.hostname === 'app.develop.seguros.redevistorias.com.br' ||
  window.location.hostname === 'localhost';

export const initializeGA = () => {
  ReactGA.initialize('G-ZEBLYS7X4V');
};

interface UserTrackingData {
  id: string;
  name: string;
  role: string;
  estateId?: string;
  estate?: { name: string };
}

export const trackLogin = (userData: UserTrackingData) => {
  ReactGA.set({
    user_id: userData.id
  });

  ReactGA.event('login', {
    username: userData.name,
    role: userData.role,
    estate_id: userData.estateId,
    estate_name: userData.estate?.name
  });
};

export const trackPageview = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};
